// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"187":"962be2b0","363":"c607b59d","732":"757f6574","746":"d17cbb48","787":"9567d9ec","991":"1670fec7"}[chunkId] + ".chunk.js";
};